import { AssistentsProps } from './Assistents.types';
import __isEmpty from 'lodash/isEmpty';
import styles from './assistents.module.scss';
// @ts-ignore
import Imatge from 'components/corporatiu/Imatge';

const Assistents = (props: Readonly<AssistentsProps>) => {
    const { items } = props;

    if (__isEmpty(items)) return null;

    return (
        <div className={styles.assistents}>
            {items?.map((item, index) => (
                <div key={index} className={styles.aplicacio}>
                    <div>
                        <Imatge src={item.imatge} alt={item.alt} loading='lazy' width='100' height='100' />
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: item.descripcio }} />
                </div>
            ))}
        </div>
    );
};

export default Assistents;
